window.Popbox = function () {
  let
    current = null
  const
    template = (function () {
      let modal = document.createElement('dialog-modal')
      modal.innerHTML = `
        <dialog-content>
          <dialog-header>
            <dialog-title></dialog-title>
          </dialog-header>
          <dialog-body></dialog-body>
          <dialog-actions></dialog-actions>
        </dialog-content>
      `
      return modal
    })(),
    setAttributes = function (attributes) {
      Object.keys(attributes).forEach(function (key) {
        current.setAttribute(key, attributes[key])
      })
    },
    setTitle = function (optionsOrTitle) {
      let node = current.querySelector('dialog-title')
      let title = ''
      if (typeof optionsOrTitle === 'object' && optionsOrTitle.hasOwnProperty('title')) {
         title = optionsOrTitle.title
      } else if (typeof optionsOrTitle === 'string') {
        title = optionsOrTitle
      }
      node.innerHTML = title
    },
    setContent = function (content) {
      let node = current.querySelector('dialog-body')
      if (typeof content.hasChildNodes === 'function') {
        node.innerHTML = ''
        node.appendChild(content)
      } else if (typeof content === 'string') {
        node.innerHTML = content
      }
    },
    appendToBody = function () {
      document.querySelector('body').appendChild(current)
    },
    launchScripts = function () {
      if (current.hasAttribute('runscripts')) {
        current.querySelectorAll('script').forEach(scrpt => {
          eval(scrpt.textContent)
        })
      }
    },
    show = function () {
      current.setAttribute('open', '')
    },
    hide = function () {
      current.setAttribute('closing', '')
    },
    destroy = function () {
      current.setAttribute('die', '')
    },
    create = function (content, options = {}) {
      if (!content) {
        return console.error('Popbox dialog content required')
      } else {
        current = template.cloneNode(true)
        setContent(content)
        setAttributes(options)
        setTitle(options)
        appendToBody()
        launchScripts()
        show()

        return {
          setTitle,
          setContent,
          show,
          hide,
          destroy,
          getNode: function (selector) { return selector ? current.querySelector(selector) : current },
          getNodes: function (selector) { return current.querySelectorAll(selector) }
        }
      }
    }

  return { create }
}
